import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, AbstractControl } from '@angular/forms';
import { combineLatest, distinctUntilChanged, map, Observable, startWith, Subject, switchMap, takeUntil } from 'rxjs';
import { App_DisableNew, App_DisableNewConstraint, App_FormCreatorJson, App_FormFieldLabel, App_TrueField } from 'src/app/utils/interfaces';
import { Type_FieldOrLabel } from 'src/app/utils/types';
import { SafeLiftService } from 'src/app/services/app/safelift.service';
import { buildDisableNewConstraintResults } from 'src/app/utils/utils';
import { ModalController } from '@ionic/angular';
import { CModalZoomImageComponent } from '../c-modal/c-modal-zoom-image/c-modal-zoom-image.component';

@Component({
  selector: 'app-c-label',
  templateUrl: './c-label.component.html',
  styleUrls: ['./c-label.component.scss'],
})
export class CLabelComponent implements OnInit, OnDestroy {
  @Input({ required: true }) label!: App_FormFieldLabel;
  @Input({ required: true }) forms!: FormGroup;
  @Input({ required: true }) display!: App_FormCreatorJson;

  hide = false;
  destroyComponent$: Subject<boolean> = new Subject();

  constructor(
    private safeLiftService: SafeLiftService,
    private modalController: ModalController
  ) { }

  ngOnInit(): void {
    if (this.label.disable_new?.hideIfDisabled === true) {
      this.hide = this.safeLiftService.isFieldHidden(this.label as unknown as App_TrueField, this.forms, this.display);
    }
    if (this.label.disable_new !== undefined) {
      this.setConditionalDisable(this.label.disable_new);
    }
  }
  ngOnDestroy(): void {
    this.destroyComponent$.next(true);
  }

  setConditionalDisable(disable_new: App_DisableNew) {
    const operation = disable_new.operation;
    const constraints = disable_new.constraints;
    
    if (typeof operation === 'string') {
      const matches = operation.match(/\$[\w]+/g);

      if (Array.isArray(matches)) {
        if (
          Array.isArray(constraints)
          && constraints.length > 0
          && constraints.every(constraint =>
            typeof constraint.champ === 'string'
            && constraint.champ !== this.label.name
            && typeof constraint.id === 'string'
            && typeof constraint.type === 'string'
            && constraint.value !== undefined
          )
          && matches.every(matchStr => constraints.find(constraint => constraint.id === matchStr))
        ) {
          const observables = constraints.reduce<(Observable<{ id: string, champNom: string, valuetoReplace: string, constraintValue: any, field: AbstractControl }> | undefined)[]>((acc, constraint) => {
            const field = this.safeLiftService.findFieldInFormEntity(this.forms, constraint.champ);
            const champ = this.safeLiftService.findFieldinFormParams(this.display, constraint.champ);

            if (field instanceof AbstractControl) {
              return [
                ...acc,
                field.valueChanges.pipe(
                  startWith(field.value),
                  distinctUntilChanged()
                ).pipe(map(value => ({
                  id: constraint.id,
                  champNom: constraint.champ,
                  champ,
                  valuetoReplace: constraint.value,
                  constraintValue: value,
                  field,
                  constraint
                })))
              ];
            }

            return [...acc, undefined];
          }, []);

          if (observables.every(obs => obs instanceof Observable)) {
            const obs$ = combineLatest(
              observables.map(_ => _ as Observable<{ id: string, champNom: string, champ: Type_FieldOrLabel | undefined, valuetoReplace: string, constraintValue: any, field: AbstractControl,constraint: App_DisableNewConstraint;  }>)
            ).pipe(
              takeUntil(this.destroyComponent$),
              map((ctrlsFields) => {
                try {
                  const arrayOfTransformedValues = buildDisableNewConstraintResults(
                    operation,
                    constraints,
                    (champ) => {
                      const c = this.safeLiftService.findFieldInFormEntity(this.forms, champ);
                      return c instanceof AbstractControl ? c : undefined;
                    },
                    (champ) => this.safeLiftService.findFieldinFormParams(this.display, champ),
                  );

                  const evaluatedOperation = this.evaluateOperation(operation, arrayOfTransformedValues);
                  return evaluatedOperation;
                } catch (error) {
                  console.error('[disable_new] Evaluation error:', error);
                  return false;
                }
              }),
              distinctUntilChanged(),
            );

            obs$.subscribe((res) => {
              this.hide = disable_new.hideIfDisabled === true ? !res : false;
            });
          }
        }
      }
    }
  }

  evaluateOperation(operation: string, arrayOfTransformedValues: { id: string, value: boolean }[]): boolean {
    const operationReplaced = operation.replace(/\$[\w]+/g, str => {
      const found = arrayOfTransformedValues.find(v => v?.id === str);
      return found ? found.value.toString() : 'false';
    });

    try {
      const evaluated = eval(operationReplaced);
      return typeof evaluated === 'boolean' ? evaluated : false;
    } catch (error) {
      return false;
    }
  }



  onClickPotentialImage($event: any) {
    const target = $event.target;
    if (target.nodeName === `IMG`) {
      this.modalController.create({
        component: CModalZoomImageComponent,
        componentProps: {
          html: target.outerHTML
        },
        cssClass: 'modal-img',
      }).then(_ => _.present())
    }
  }

}
